
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

// > services/types <
import { Waybill } from '@/modern/modules/m-dispatcher-module/services/types/waybill.types'

export default defineComponent({
    props: {
        waybill: {
            type: Object as PropType<Waybill>,
            required: true
        },
    },
    emits: ['request-for-payment'],
    setup(props, { emit }) {
        const onRequestForPayment = () => {
            emit('request-for-payment', props.waybill)
        }

        return {
            onRequestForPayment
        }
    }
})
